/** @jsx jsx */
import { jsx } from '@emotion/core'
import { VFlow } from 'bold-ui'
import { LabelMap } from 'util/fields-labels/model-fieldsLabels'
import { MetaRoot } from 'util/metaPath'
import { ErrorObject } from 'util/validation'

import { convertErrorsToModalItems } from './convertErrorsToModalItems'
import { FormErrorModel, ValidationErrorModalConfig } from './model-validationErrorsModal'
import { ValidationErrorsModalSection } from './ValidationErrorsModalSection'

interface ValidationErrorsModalProps<TFormModel> {
  labels: LabelMap<TFormModel>
  errors: ErrorObject<TFormModel> & FormErrorModel
  meta: MetaRoot<TFormModel>
  config?: ValidationErrorModalConfig<TFormModel>
}

export function ValidationErrorsModal<TFormModel extends object>(props: ValidationErrorsModalProps<TFormModel>) {
  const { labels, errors, config, meta } = props

  const items = convertErrorsToModalItems<TFormModel>(errors, labels, config, meta)

  return (
    <VFlow>
      {items.map((item, key) => (
        <ValidationErrorsModalSection section={item} key={key} />
      ))}
    </VFlow>
  )
}
